// CTA section content
export const cta = {
  headline: 'Ready to Automate Your Presentations?',
  lead: 'Get started with SlideFactory today. Free trial available for enterprise teams. See how AI-powered automation transforms your presentation workflow.',
  buttons: [
    { label: 'Request Demo', href: 'mailto:contact@slidefactory.app', style: 'primary' },
    { label: 'View Documentation', href: 'https://docs.slidefactory.app', style: 'stroke' }
  ]
}

// Newsletter / Subscribe section
export const newsletter = {
  headline: 'Stay Updated',
  lead: 'Get product updates, AI presentation tips, and automation best practices delivered to your inbox.',
  placeholder: 'Enter Your Email',
  buttonLabel: 'Subscribe'
}
